import React from 'react';
import { APPT_ENUMS, formatMiles, renderStaffName } from 'utils';
import { DateRow, DetailItem, LocalDateRow } from 'components';
import { SubjectEnums } from '../../constants';
import { UNAVAILABLE } from '../../../constants';

export const OtherItems = ({ item }) => {
    return (
        <>
            <div className="full-width">
                {/*{item?.staff &&*/}
                {/*    <DetailItem*/}
                {/*        title={'Staff'}*/}
                {/*        value={renderStaffName(item?.staff)}*/}
                {/*    />*/}
                {/*}*/}
                {item?.payCodeTypeName && (
                    <DetailItem
                        title={'Staff Paycode'}
                        value={
                            item?.payCodeTypeName
                                ? `${item.payCodeTypeName} ${item?.payCodeTypeCode ? `(${item?.payCodeTypeCode})` : ''}`
                                : null
                        }
                    />
                )}
                {item?.staffApptType && (
                    <DetailItem title={'Type'} value={SubjectEnums?.find((i) => i?.id === item?.staffApptType)?.name} />
                )}
                {item?.subject && <DetailItem title={'Subject'} value={item?.subject} />}

                {item?.type === APPT_ENUMS.DRIVE && (
                    <div>
                        <DetailItem title={'Start Address'} value={item?.startAddress ? item.startAddress?.formattedAddress : '--'} />
                        <DetailItem title={'End Address'} value={item?.endAddress ? item.endAddress?.formattedAddress : '--'} />
                        <DetailItem title={'Miles'} value={formatMiles(item?.miles)} />
                    </div>
                )}

                <DetailItem
                    title={'Created At'}
                    value={
                        item?.creatorFullName && item?.createdDate ? (
                            <div className="flex-align-center" style={{ gap: 4 }}>
                                <p>{item?.creatorFullName ? `${item.creatorFullName} - ` : ''}</p>
                                {/*{item?.createdDate ? <DateRow date={item?.createdDate} /> : ''}*/}
                                {item?.createdDate ? <LocalDateRow date={item?.createdDate} /> : ''}
                            </div>
                        ) : (
                            '--'
                        )
                    }
                />
                <DetailItem
                    title={'Last Modified'}
                    value={
                        item?.editorFullName && item?.editedDate ? (
                            <div className="flex-align-center" style={{ gap: 4 }}>
                                <p>{item?.editorFullName ? `${item.editorFullName} - ` : ''}</p>
                                {/*{item?.editedDate ? <DateRow date={item?.editedDate} /> : ''}*/}
                                {item?.editedDate ? <LocalDateRow date={item?.editedDate} /> : ''}
                            </div>
                        ) : (
                            '--'
                        )
                    }
                />

                {item?.type === UNAVAILABLE && <DetailItem title={'Notes'} value={item?.creationNote ? item?.creationNote : '--'} />}
                {/*<DetailItem*/}
                {/*    title={'Created Date'}*/}
                {/*    value={item?.createdDate ? <DateRow date={item?.createdDate} /> : '--'}*/}
                {/*/>*/}
                {/*<DetailItem*/}
                {/*    title={'Created By'}*/}
                {/*    value={item?.creatorFullName ? item.creatorFullName : '--'}*/}
                {/*/>*/}
                {/*<DetailItem*/}
                {/*    title={'Last Modified Date'}*/}
                {/*    value={item?.editedDate ? <DateRow date={item?.editedDate} /> : '--'}*/}
                {/*/>*/}
                {/*<DetailItem*/}
                {/*    title={'Last Modified By'}*/}
                {/*    value={item?.editorFullName ? item?.editorFullName : '--'}*/}
                {/*/>*/}
            </div>
        </>
    );
};
